import script from "./sellerInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./sellerInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./sellerInfoModal.vue?vue&type=style&index=0&id=26e7a84c&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26e7a84c"]])

export default __exports__